import React, { useState, useEffect, useRef, useCallback } from "react";
import { pb4y as api } from "../../../../services/apis";
import { producaov2 as api2 } from "../../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  SemanticTable,
  ContainerInputSearch,
  Input,
  Select,
} from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const ListarPocket = (props) => {
  const [pocket, setPocket] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const linguagem = useRef("BR");
  const segment = useRef(0);
  const optionsSelect = [
    { id: "BR", text: "BR" },
    { id: "EN", text: "EN" },
    { id: "ES", text: "ES" },
    { id: "DE", text: "DE" },
    { id: "RU", text: "RU" },
    { id: "ZH", text: "ZH" },
    { id: "FR", text: "FR" },
    { id: "IT", text: "IT" },
  ];
  const optionsSelectSegments = [
    { id: 0, text: "Categorias" },
    { id: "1", text: "Estratégia" },
    { id: "2", text: "Liderança e Gestão" },
    { id: "3", text: "Marketing e Vendas" },
    { id: "4", text: "Empreendedorismo" },
    { id: "5", text: "Dinheiro e Investimento" },
    { id: "6", text: "Biografias" },
    { id: "8", text: "Cultura Corporativa" },
    { id: "9", text: "Motivação e Inspiração" },
    { id: "10", text: "Comunicação e Networking" },
    { id: "11", text: "Produtividade" },
  ];

  useEffect(() => {
    loadAuth();
    loadPocket();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadPocket = async () => {
    await api
      .get(`pocketbooks?lang=${linguagem.current}&no_aws=true&segment=${segment.current}`)
      .then(async (res) => {
        let logs = { local: "PocketBook", texto: `listou os artigos` };
        await api2.post("system_logs", { acao: JSON.stringify(logs) });
        setPocket(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os valores", err, "error");
        setLoading(false);
      });
  };

  const removePocket = useCallback(
    (id) => {
      swal("Remoção de valor", "Você tem certeza que quer remover ?", "").then(
        (res) => {
          if (res) {
            api.delete(`pocketbooks/${id}`).then(async (res) => {
              let logs = {
                local: "PocketBook",
                texto: `deletou o artigo de id=${id}`,
              };
              await api2.post("system_logs", { acao: JSON.stringify(logs) });
              const newPocket = [...pocket].filter((valor) => valor.id !== id);
              setPocket(newPocket);
            });
          }
        }
      );
    },
    [pocket]
  );

  const modifyLinguagem = (e) => {
    const lingua = e.target.value;
    linguagem.current = lingua;
    loadPocket();
  };
  const modifySegment = (e) => {
    const seg = e.target.value;
    segment.current = seg;
    loadPocket();
  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Lista PocketBook</Title>
            <ContainerInputSearch>
              <Select onChange={modifyLinguagem}>
                {optionsSelect.map((valor) => (
                  <option value={valor.id}>{valor.text}</option>
                ))}
              </Select>
              <Select onChange={modifySegment}>
                {optionsSelectSegments.map((valor) => (
                  <option value={valor.id}>{valor.text}</option>
                ))}
              </Select>

              <Input
                type="text"
                placeholder="Pesquise pelo titulo"
                onChange={(e) => setSearch(e.target.value)}
              />
              <Link to="/admin/blog/pocketbook4you/criar">
                <Button>Criar</Button>
              </Link>
            </ContainerInputSearch>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell style={{ width: "5%" }}>
                    ID
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "80%" }}>
                    Titulo
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "15%" }}>
                    Ações
                  </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              {pocket.length > 0 ? (
                <SemanticTable.Body>
                  {pocket
                    .filter((valor) =>
                      valor.titulo.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((valor, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>{valor.id}</SemanticTable.Cell>
                        <SemanticTable.Cell>{valor.titulo}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <>
                            <Button
                              icon="edit icon"
                              size="small"
                              color={"blue"}
                              onClick={() =>
                                window.open(
                                  `/admin/blog/pocketbook4you/detalhes/${linguagem.current}/${valor.id}`
                                )
                              }
                            />

                            <Button
                              icon="trash icon"
                              size="small"
                              color={"red "}
                              onClick={() => removePocket(valor.id)}
                            />
                          </>
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))}
                </SemanticTable.Body>
              ) : (
                <h3>Nenhum valor encontrado</h3>
              )}
            </SemanticTable>
          </Content>
        )}
        ;
      </Container>
    </>
  );
};

export default withRouter(ListarPocket);
